<template>
    <div>
        <form id="inicis_form" name="inicis_form" method="post" action="#">
        </form>
        <v-dialog/>
    </div>
</template>
<script>
//import {inicisAuthResult} from '@/api/step3/identificationVerfication'
export default {
    name: "ResultInicisAuthPop",
    data() {
      return {}
    },
    created() {
        this.getInfo();
    },
    watch: {
    // 라우트가 변경되면 메소드를 다시 호출됩니다.
    '$route': 'getInfo'
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KMC 결과 정보
         **/
        getInfo() {
          //  alert( this.$route.query.msgCd)
            let msgCd = this.$route.query.msgCd

            if(msgCd === "SUCCESS" ){
                 if(typeof(window.parent.cbAuthPop) == "function") {
                        window.parent.cbAuthPop(msgCd)
                    } else {
                        window.opener.cbAuthPop(msgCd)
                    }
                    window.close()

            }else{
                alert('본인 인증을 실패했습니다.');
                window.close()
            }

        },
    },
}
</script>

<style scoped>

</style>